import { createCircleIcon } from '../createIcon.tsx';

export const ClockIcon = createCircleIcon('ClockIcon', <polyline points="12 6 12 12 16 14" />);
